module.exports = __webpack_public_path__ + "static/exit-intent-mobile-21a6972b927a35ec20441b3413c9eeb3.jpg";